import React, { Component } from 'react';

class EirBusinessSearch extends Component {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        
    }

    render() {
        return (
            <div className="position-relative mt-md-1 mt-lg-4 d-flex">
                <div className="d-none d-lg-inline meganav-cart-label"></div>
                <div className="eir-icon meganav-icon-search icon-search text-right"/>
            </div>
        );
    }
}

export default EirBusinessSearch;